"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconMegaphone = Experimental__IconMegaphone;
exports.IconMegaphone = IconMegaphone;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconMegaphone/index.tsx)
 */
function IconMegaphone(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M11.85 1.083c.246.13.4.385.4.664V13.25a.75.75 0 0 1-1.138.642l-4.473-2.707a1.25 1.25 0 0 0-.647-.18h-.314l1.28 2.232c.207.36.084.82-.274 1.027l-.224.13c-.578.336-1.399.724-2.327.573-.965-.158-1.816-.853-2.558-2.146L.233 10.48A1.245 1.245 0 0 1 0 9.756V5.648c0-.69.56-1.25 1.25-1.25h4.68c.252 0 .499-.077.707-.22l4.438-3.05a.75.75 0 0 1 .774-.045Zm-9.588 9.922.61 1.062c.622 1.085 1.154 1.359 1.505 1.416.274.045.568-.017.9-.164L4.176 11.4a.822.822 0 0 1-.013-.023l-.196-.372H2.262Zm8.488-7.833L7.486 5.414a2.75 2.75 0 0 1-1.557.484H1.5v3.607h4.492c.502 0 .994.137 1.424.397l3.334 2.018V3.172Zm5.17 1.638a.75.75 0 0 1-.333 1.008l-1.45.73a.75.75 0 1 1-.674-1.34l1.45-.73a.75.75 0 0 1 1.007.333ZM13.8 7.316a.75.75 0 0 0 0 1.5h1.45a.75.75 0 0 0 0-1.5H13.8Zm.337 2.269a.75.75 0 1 0-.674 1.34l1.45.73a.75.75 0 1 0 .674-1.34l-1.45-.73Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M17.458 2.11A1 1 0 0 1 18 3v17a1 1 0 0 1-1.581.814L9.94 16.186A1 1 0 0 0 9.36 16h-.577l2.136 3.699a1 1 0 0 1-.366 1.366l-.303.174c-.796.46-1.93.974-3.236.683-1.319-.293-2.51-1.334-3.611-3.242l-2.034-3.523A1.99 1.99 0 0 1 1 14V9a2 2 0 0 1 2-2h6.36a1 1 0 0 0 .58-.186l6.479-4.628a1 1 0 0 1 1.039-.075ZM3.01 14h6.35a3 3 0 0 1 1.743.559L16 18.057V4.943l-4.897 3.498A3 3 0 0 1 9.359 9H3v4.983l.01.017Zm1.155 2 .97 1.68c.973 1.687 1.78 2.172 2.313 2.29.384.085.78.018 1.22-.168l-1.742-3.02a.948.948 0 0 1-.015-.027L6.506 16H4.165Zm18.73-8.447a1 1 0 0 1-.448 1.341l-2 1a1 1 0 1 1-.894-1.788l2-1a1 1 0 0 1 1.341.447ZM19 12a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm.106 2.553a1 1 0 0 1 1.341-.447l2 1a1 1 0 1 1-.894 1.788l-2-1a1 1 0 0 1-.447-1.341Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconMegaphone is deprecated and will be archived soon. Use IconMegaphone instead.
 */
function Experimental__IconMegaphone(props) {
  return /*#__PURE__*/_react["default"].createElement(IconMegaphone, props);
}